<template>
  <div class="app-menu">
    <div class="row">
      <button @click="toggleCheckedVisibility">{{ checkedItemsVisible ? 'הסתרת' : 'הצגת'}} פריטים מסומנים</button>
    </div>
    <div class="row">
      <button @click="userSignOut" class="destructive">התנתקות מהחשבון</button>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: "AppMenu",
    computed: {
      ...mapState(['checkedItemsVisible'])
    },
    methods: {
      ...mapActions(['userSignOut', 'toggleCheckedVisibility'])
    },
  }
</script>

<style scoped lang="sass">
  .app-menu
    position: fixed
    top: $size-64
    z-index: 20
    background-color: $white
    width: 100%
    left: 0
    padding: $size-12
    box-shadow: $shadow

    +dark
      background-color: $black-5

  .row:not(:first-child)
    margin-top: $size-12
</style>
